import { useQueryWithUserId } from '@northladder/services';

import { TENANT_CONFIG_API } from '../tenantClient';
import { ITenantConfigOptions } from '../types';

/**
 * This will be used to track the tenant config query.
 */
const TENANT_CONFIG_QUERY_KEY = 'tenant-config-query-key';

/**
 * This hook fetches the tenant config for the provided `identifier`.
 */
export const useTenantDetailsQuery = ({
  identifier,
  logoUrl,
}: ITenantConfigOptions) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [TENANT_CONFIG_QUERY_KEY, identifier, logoUrl],
    queryFn: () =>
      TENANT_CONFIG_API.fetchTenantDetails({
        identifier,
        logoUrl,
      }),
    retry: false,
    enabled: identifier.length > 7,
    refetchOnWindowFocus: false,
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
